import React from 'react'
import PropTypes from 'prop-types'

const MapInfoWindow = props => {

    const { property } = props
    const { propPicture, addressLine1, propertyName, omniViewPropertyType, subType, city, state } = property
    // console.log('property:::', property) omniViewPropertyId, MetropolitanStateAreaName, zipCode propertyPropertyCounty

    function getAddress() {
        let address = ''
        address = `${city ? city : ''}, ${state ? state : ''}`
        address = address.replace(',,', ',')
        address = address.replace(', ,', ',')

        return address
    }

    function getType() {
        return `${omniViewPropertyType} | ${subType}`
    }

    return (
        <div className="flex flex-col py-2 pl-2 space-y-4 overflow-y-hidden" style={{ 'width': '200px !important' }}>

            {propPicture &&
                <div>
                    <img src={propPicture} alt="" className="w-full" imgindex="0" data-u="image" style={{ 'width': '200px', 'height': '130px' }} />
                </div>
            }
            <div className="text-2 ">
                <strong>{propertyName}</strong>
            </div>
            <div className="font-normal">
                <div className="flex flex-col">
                    <span>{addressLine1}</span>
                    <span>{getAddress()}</span>
                </div>
            </div>
            <div className="font-normal">
                {getType()}
            </div>
        </div>
    )
}

export default MapInfoWindow

MapInfoWindow.propTypes = {
    property: PropTypes.any
}
